import * as tslib_1 from "tslib";
import { Base } from "../../components/base-component";
import { AnalyticsService } from "../../services/analytics.service";
import "./form-item-life-cover-insurance.component.scss";
var FormItemLifeCoverInsurance = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemLifeCoverInsurance, _super);
    function FormItemLifeCoverInsurance(element) {
        return _super.call(this, element) || this;
    }
    FormItemLifeCoverInsurance.prototype.init = function () {
        this.form = this.element.querySelector("form");
        this.submitBtn = this.element.querySelector(".js-life-cover-insurance__button");
    };
    FormItemLifeCoverInsurance.prototype.bindEvents = function () {
        var _this = this;
        this.submitBtn.addEventListener("click", function (event) {
            var _button = event.target;
            var _form = _button.closest("form");
            var formFields = _form.querySelectorAll("input, select");
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll(".form__group--error"));
            if (valid.length === 0) {
                _this.submitForm(_form);
            }
        });
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
    };
    FormItemLifeCoverInsurance.prototype.submitForm = function (form) {
        // success screens
        var loader = form.querySelector(".form__loader--container");
        var thankYou = form.querySelector(".form__thankyou--container");
        var fieldsContainer = form.querySelector(".form__fields--container");
        // additional containers
        var success = form.querySelector(".form__success--container");
        var error = form.querySelector(".form__error--container");
        var postData = "";
        // Hidden fields
        var campaignName = form.querySelector("input[name=campaignName]");
        postData += "&compaignname=" + (campaignName ? campaignName.value : "");
        // form fields
        var serviceType = form.querySelector("input[name=serviceType]");
        if (serviceType) {
            postData += "service-type=" + serviceType.value;
        }
        var product = form.querySelector("input[name=product]");
        if (product) {
            postData += "&product=" + product.value;
        }
        var description = form.querySelector("input[name=description]");
        if (description) {
            postData += "&description=" + description.value;
        }
        var email = form.querySelector("input[name=email]");
        if (email) {
            postData += "&email=" + email.value;
        }
        var recipient = form.querySelector("input[name=recipient]");
        if (recipient) {
            postData += "&recipient=" + recipient.value;
        }
        var subject = form.querySelector("input[name=subject]");
        if (subject) {
            postData += "&subject=" + subject.value;
        }
        var redirect = form.querySelector("input[name=redirect]");
        if (redirect) {
            postData += "&redirect=" + redirect.value;
        }
        var _firstName = this.form.querySelector("input[name=first-name]");
        if (_firstName) {
            postData += "&firstname=" + _firstName.value;
        }
        var _surname = this.form.querySelector("input[name=last-name]");
        if (_surname) {
            postData += "&surname=" + _surname.value;
        }
        var _contact = this.form.querySelector("input[name=contact-number]");
        if (_contact) {
            postData += "&contact=" + _contact.value;
        }
        // loader + hide form
        loader.classList.add("active");
        fieldsContainer.classList.add("hidden");
        // variables
        var analyticsService = new AnalyticsService();
        var url = this.baseUrl + "/services/lifecoverservice.jsp";
        // service
        this.formsService
            .postForm(url, postData)
            .then(function (response) {
            loader.classList.remove("active");
            if (!response.data || response.data.match(/(invalid)/gi)) {
                analyticsService.dtmRecordSiteError("noerrorcode|invalid response");
                thankYou.classList.add("active");
                success.classList.remove("active");
                success.classList.add("hidden");
                error.classList.remove("hidden");
                error.classList.add("active");
            }
            else {
                analyticsService.dtmFormComplete("complete", response.code, false, "", email.value, _contact.value);
                thankYou.classList.add("active");
                error.classList.remove("active");
                error.classList.add("hidden");
                success.classList.remove("hidden");
                success.classList.add("active");
            }
        })
            .catch(function (response) {
            // service failed
            analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            loader.classList.remove("active");
            fieldsContainer.classList.remove("hidden");
        });
    };
    return FormItemLifeCoverInsurance;
}(Base));
export { FormItemLifeCoverInsurance };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-life-cover-insurance/form-item-life-cover-insurance.component.ts
// module id = 937
// module chunks = 0